import { ReactNode } from 'react';
import cn from 'classnames';

const LINE_CLAMP_CLASSES: Record<number, string> = {
  1: 'line-clamp-1',
  2: 'line-clamp-2',
  3: 'line-clamp-3',
  4: 'line-clamp-4',
  5: 'line-clamp-5',
  6: 'line-clamp-6',
};

type Props = {
  lines: number;
  children: ReactNode;
  className?: string;
};

const Truncate = ({ lines, children, className }: Props) => (
  <div className={cn(LINE_CLAMP_CLASSES[lines], 'text-ellipsis', className)}>{children}</div>
);

export default Truncate;
